<template>
	<div>
		<div class="bigBox">
			<div class="leftCont">
				<div class="banner-5">
					<div class="mendio2">
						<div class="name6">合作伙伴全国火热招募中</div>
						<div class="Intro6">建立共赢发展模式 构建本地化移动互联平台</div>
						<div class="btnBox">
							<div class="btn1" @click="drawer = true">申请合作</div>
							<div class="btn2" @click="dialogVisible = true">伙伴登录</div>
						</div>
					</div>
				</div>
				<div class="chainse">
					<div class="chainTs">门槛低，收益高</div>
					<div class="chainC">
						<div class="bigChain">
							<div class="chainCtxt">
								<div class="chainCtxt1">获取3重收益</div>
								<div class="chainCtxt2">产品销售提成、管理提成、用户运营培训费用，给您带来源源不断的收入。</div>
							</div>
							<div class="chainCtxt">
								<div class="chainCtxt1">汇聚区域商家资源</div>
								<div class="chainCtxt2">协助打造异业联盟，凝聚异业商家力量，实现多方共赢</div>
							</div>
							<div class="chainCtxt" style="margin: unset;">
								<div class="chainCtxt1">门槛低，支持多，还有区域保护</div>
								<div class="chainCtxt2">只要愿意，即可申请成为合作伙伴；每个区域设置一个区域合伙人，专属服务经理支持</div>
							</div>
						</div>
						<img mode="widthFix" src="../assets/images/temb10.jpg" class="chanPic" />
					</div>
					<div class="knowMore" @click="drawer = true">申请合作 ></div>
				</div>
				<div class="chainse" style='display: none;'>
					<div class="chainTs">产品介绍</div>
					<div class="goodsBox">
						<div class="goods">
							<div class="goodsmal">
								<img class="goods-pic" src="../assets/images/logo.png" />
								<div class="goods-name">MOMI外卖</div>
								<div class="goods-intro">外卖SaaS平台</div>
								<div class="goods-cont hmb">MOMI外卖，为餐饮店打造专属线上入口，提高门店知名度、利润空间、资金周转效率。</div>
								<div class="goods-btn" @click="drawer = true">申请合作</div>
								<div class="goods-conmu">咨询热线：159 8989 7729</div>
							</div>
						</div>
						<div class="goods">
							<div class="goodsmal">
								<img class="goods-pic" src="../assets/images/ft.png" />
								<div class="goods-name">MOMI生态平台</div>
								<div class="goods-intro">构建生态系统，提升品牌价值</div>
								<div class="goods-cont hmb">为连锁店或品牌商提供的生态平台解决方案，整合企业相关资源，从而实现共存互利。</div>
								<div class="goods-btn" @click="drawer = true">申请合作</div>
								<div class="goods-conmu">咨询热线：159 8989 7729</div>
							</div>
						</div>
						<div class="goods">
							<div class="goodsmal">
								<img class="goods-pic" src="../assets/images/sc.png" />
								<div class="goods-name">MOMI商城</div>
								<div class="goods-intro">线上线下一体化经营</div>
								<div class="goods-cont hmb">实现线上与线下相结合，通过24小时在线的MOMI商城，打造私域流量，降低门店铺货成本。</div>
								<div class="goods-btn" @click="drawer = true">申请合作</div>
								<div class="goods-conmu">咨询热线：159 8989 7729</div>
							</div>
						</div>
					</div>
				</div>
				<div class="chainse" style='display: none;'>
					<div class="chainTs">合作伙伴条件</div>
					<div class="goodsBox">
						<div class="goods">
							<img src="../assets/images/con0.png" class="item3-pic"/>
							<div class="item2-title">认可我们文化</div>
							<div class="goods-cont">
								认同我们产品价值和文化理念，
								愿意跟我们长期合作。
							</div>
						</div>
						<div class="goods">
							<img src="../assets/images/con1.png" class="item3-pic"/>
							<div class="item2-title">具有行业背景</div>
							<div class="goods-cont">
								有互联网背景，对社交电商、
								SaaS 行业有了解。
							</div>
						</div>
						<div class="goods">
							<img src="../assets/images/con2.png" class="item3-pic"/>
							<div class="item2-title">具有销售团队</div>
							<div class="goods-cont">
								有专属且成熟的销售团队，
								负责人有团队管理经验。
							</div>
						</div>
						<div class="goods">
							<img src="../assets/images/con3.png" class="item3-pic"/>
							<div class="item2-title">具有客户资源</div>
							<div class="goods-cont">
								拥有当地丰富的企业级资源
								或线下门店资源。
							</div>
						</div>
					</div>
				</div>
				<div class="chainse">
					<div class="chainTs">合作申请流程</div>
					<div class="chsmall-box">
						<div class="item-box">
							<img src="../assets/images/picon2.png" class="item3-pic"/>
							<div class="item2-title">提交申请</div>
						</div>
						<img class="rightGo" src="../assets/images/def/right-go.png"/>
						<div class="item-box">
							<img src="../assets/images/picon4.png" class="item3-pic"/>
							<div class="item2-title">线下审核</div>
						</div>
						<img class="rightGo" src="../assets/images/def/right-go.png"/>
						<div class="item-box">
							<img src="../assets/images/picon3.png" class="item3-pic"/>
							<div class="item2-title">洽谈方案</div>
						</div>
						<img class="rightGo" src="../assets/images/def/right-go.png"/>
						<div class="item-box">
							<img src="../assets/images/picon1.png" class="item3-pic"/>
							<div class="item2-title">签约合作</div>
						</div>
					</div>
				</div>
				<!-- <div class="bottom-box">
					<div class="bottom-text">加盟摩米贝尔  合作共赢</div>
					<div class="goods-btn" @click="drawer = true">申请合作</div>
				</div> -->
			</div>
			<right-cont :activeIndex="activeIndex"></right-cont>
			<el-drawer
			  title=""
			  :append-to-body='true'
			  :visible.sync="drawer"
			  :direction="direction"
			  :before-close="handleClose">
			  <div class="contact-form">
				  <div class="contact-titl">预约咨询</div>
				  <input type="text" v-model="name" class="cont-ipt" placeholder="姓名"/>
				  <input type="number" v-model="mobile" class="cont-ipt" placeholder="手机号码"/>
				  <input type="text" v-model="conpany" class="cont-ipt" placeholder="公司名称(选填)"/> 
				  <input type="text" v-model="address" class="cont-ipt" placeholder="所在地区（选填）"/> 
				  <div class="confirm-btn" @click="subAgent">提交</div>
			  </div>
			</el-drawer>
		</div>
		<el-button :plain="true" @click="open2"></el-button>
		<el-dialog title="" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<div>
				<img class="pop-pic" src="../assets/images/qr_tool.jpg" />
				<div class="free-use">扫码登录</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import request from '../utils/request.js'	
import rightCont from '../components/rightCont.vue'
export default {
	components:{
		rightCont
	},
	data(){
		return{
			direction: 'rtl',
			activeIndex:'6',
			drawer:false,
			type:null,
			name:null,
			mobile:null,
			dialogVisible:false,
			conpany:null,
			email:null,
			address:null,
			product:null,
		}
	},
	methods:{
		handleClose(done) {
			done();
		},
		open2() {
			this.$message({
				message: '提交成功，稍后我们将会有客服人员联系您，请保持电话畅通',
				type: 'success'
			});
		 },
		async subAgent () {
			if(!this.name || !this.phone){
				this.$message({
				    message: '请输入姓名和手机号',
				    type: 'info'
				});
				return
			}
			 if (!/^1[3456789]\d{9}$/.test(this.phone)) {
					this.$message({
						message: '请填写正确的手机号',
						type: 'info'
					});
			      return;
			   }
			const res = await request({
				method:'POST', 
				url:'/soft/consult/save', 
				data:{
					name:this.name,
					mobile:this.phone,
					comp:this.conpany,
					email: '',
					addr:this.address,
					prod: 'MOMI智慧自助空间系统',
					type:1
				}
			})
			if(res.code!=0) return
			this.drawer = false,
			this.open2()
		}
		
	},
	mounted() {
		window.scroll(0, 0); 
	}
}
</script>

<style>
	@media screen and (min-width:600px) and (max-width:1200px) {
		.chsmall-box{
			display: flex;
		}
		.item-box{
			text-align: center;
			flex: 1;
		}
	
		.rightGo{
			width: 2.6vw;
			height: 4.8vw;
			margin-top: 2vw;
		}
		.bottom-box{
			margin-top: 6vw;
			padding: 4vw;
		}
		.bottom-text{
			font-size: 3.5vw;
			font-weight: bold;
		}
		.item3-pic{
			width: 8vw;
			height: 8vw;
		}
		.goods-pic{
			width: 11vw;
			height: 11vw;
		}
		.Intro6{
			padding:0 6vw;
			font-size: 3vw;
			text-align: center;
		}
		.goods-name{
			font-size: 4vw;
			font-weight: bold;
			color: #333;
			line-height: 8vw;
		}
		.goods-cont{
			margin-top: 4vw;
			font-size: 2.5vw;
			color: #969799;
			line-height: 4vw;
		}
		.goods-btn{
			width: 30vw;
			background-color:#155BD4;
			font-size: 3vw;
			line-height: 6vw;
			color: #fff;
			margin: 0 auto;
			margin-top: 4vw;
		}
		.goods-conmu{
			font-size: 3vw;
			line-height: 6vw;
			color: #969799;
			margin-top: 4vw;
		}
		.goods-intro{
			font-size: 3.5vw;
			color: #333;
			line-height: 8vw;
		}
		.goods{
			width: 80vw;
			margin: 0 auto;
			padding: 5vw;
			box-shadow:0 8px 2vw 0 rgba(61,67,77,0.08);
			margin-top: 8vw;
		}
		.btn1{
			font-size: 3vw;
			text-align: center;
			width: 30vw;
			margin: 0 auto;
			height: 6vw;
			line-height: 6vw;
			background-color: #155bd4;
			color: #fff;
			margin-top:4vw;
		}
		.btn2{
			font-size: 3vw;
			text-align: center;
			width: 30vw;
			margin: 0 auto;
			height: 6vw;
			line-height: 6vw;
			border: 1px #fff solid;
			margin-top: 4vw;
		}
		.name6{
			font-size: 3vw;
			padding-top: 8vw;
			line-height: 6vw;
			text-align: center;
		}
	}

@media screen and (max-width:600px) {
	.chsmall-box{
		display: flex;
	}
	.item-box{
		text-align: center;
		flex: 1;
	}

	.rightGo{
		width: 2.4vw;
		height: 3.6vw;	
		margin-top: 3vw;
	}
	.bottom-box{
		margin-top: 6vw;
		padding: 2vw;
	}
	.bottom-text{
		font-size: 3.5vw;
		font-weight: bold;
	}
	.item3-pic{
		width: 8vw;
		height: 8vw;
	}
	.goods-pic{
		width: 11vw;
		height: 11vw;
	}
	.Intro6{
		padding:0 6vw;
		font-size: 2vw;
		text-align: center;
	}
	.goods-name{
		font-size: 4vw;
		font-weight: bold;
		color: #333;
		line-height: 8vw;
	}
	.goods-cont{
		margin-top: 4vw;
		font-size: 2.5vw;
		color: #969799;
		line-height: 4vw;
	}
	.goods-btn{
		width: 30vw;
		background-color:#155BD4;
		font-size: 2vw;
		line-height: 4vw;
		color: #fff;
		margin: 0 auto;
		margin-top: 2vw;
	}
	.goods-conmu{
		font-size: 2vw;
		line-height: 4vw;
		color: #969799;
		margin-top: 2vw;
	}
	.goods-intro{
		font-size: 3.5vw;
		color: #333;
		line-height: 8vw;
	}
	.goods{
		width: 80vw;
		margin: 0 auto;
		padding: 5vw;
		box-shadow:0 8px 2vw 0 rgba(61,67,77,0.08);
		margin-top: 8vw;
	}
	.btn1{
		font-size: 2vw;
		text-align: center;
		width: 30vw;
		margin: 0 auto;
		height: 4vw;
		line-height: 4vw;
		background-color: #155bd4;
		color: #fff;
		margin-top:2vw;
	}
	.btn2{
		font-size: 2vw;
		text-align: center;
		width: 30vw;
		margin: 0 auto;
		height: 4vw;
		line-height: 4vw;
		border: 1px #fff solid;
		margin-top: 2vw;
	}
	.name6{
		font-size: 3vw;
		padding-top: 2vw;
		line-height: 6vw;
		text-align: center;
		padding-top: 14vw;
	}
}
@media screen and (min-width:1200px) {
	.bottom-btn{
		cursor: pointer;
		background-color: #155bd4;
		width: 158px;
		color: #fff;
		font-size: 16px;
		line-height: 24px;
		padding: 8px;
		display: block;
		margin: 0 auto;
		text-align: center;
		border-radius: 2px;
		margin-top: 24px;
	}
	.bottom-text{
		font-size: 26px;
		color: #323233;
		line-height: 36px;
	}
	.bottom-box{
		text-align: center;
		background-color: #f7f8fa;
		width: 100%;
		padding: 72px 0;
	}
	.item3-pic{
		width: 72px;
		height: 72px;
		margin-bottom: 16px;
	}
	.rightGo{
		width: 14px;
		height: 22px;	
		margin-top: 25px;
	}
	.item2-title{
		font-size: 20px;
		color: #323233;
		line-height: 28px;
		margin-bottom: 8px;
	}
	.item2-p{
		color: #969799;
		font-size: 14px;
		line-height: 20px;
	}
	.item2-pic{
		width: 32px;
		height: 32px;
		margin-bottom: 16px;
	}
	.fstSpan{
		background-image: url('../assets/images/def/date.png');
		background-size: 14px 14px;
		background-repeat: no-repeat;
		background-position: 0;
		padding-left: 20px;
		text-align: left;
		margin-left: 5px !important;
	}
	.secSpan{
		margin-left: 20px;
		background-image: url('../assets/images/def/address.png');
		background-size: 12px 16px;
		background-repeat: no-repeat;
		background-position: 0;
		padding-left: 20px;
		text-align: left;
		margin-left: 5px !important;
	}
	.knowMore{
		cursor: pointer;
	}
	.adver-text{
		display: flex;
	}
	.adver-time{
		font-size: 14px;
		color: #969799;
		line-height: 20px;
		margin-top: 2px;
		text-align: left;
	}
	.adver-title{
		flex: 1;
		font-size: 16px;
		color: #323233;
		line-height: 28px;
		text-align:left
	}
	.adver-btn{
		cursor: pointer;
		font-size: 12px;
		color: #155bd4;
		line-height: 28px;
		text-align: left;
	}
	.nst{
		padding: 24px 16px !important;
		
	}
	.adver-pic{
		width: 100%;
		margin-bottom: 16px;
	}
	.st{
		margin-bottom: 8px;
	}
	.chaiIntro{
		color: #969799;
		margin-bottom: 36px;
		font-size: 20px;
		line-height: 28px;
	}
	.goods-conmu{
		color: #969799;
		font-size: 14px;
		line-height: 20px;
	}
	.goods-btn{
		cursor: pointer;
		background-color: #155bd4;
		width: 158px;
		color: #fff;
		font-size: 16px;
		line-height: 24px;
		padding: 8px;
		display: block;
		margin: 0 auto;
		text-align: center;
		border-radius: 2px;
		margin-bottom: 10px;
	}
	.goods-cont{
		color: #969799;
		font-size: 12px;
		line-height: 20px;
	}
	.goods-cont.hmb{
		margin-bottom: 30px;
		height: 120px;
	}
	.goods-intro{
		font-size: 16px;
		color: #323233;
		line-height: 24px;
		margin-bottom: 30px;
	}
	.goods-name{
		font-size: 26px;
		color: #323233;
		line-height: 36px;
		margin-bottom: 4px;
	}
	.goods-pic{
		width: 72px;
		height: 72px;
		display: block;
		margin: 0 auto 24px;
	}
	.goodsBox{
		display: flex;
	}
	.goodsmal{
		padding: 48px 24px;
		
		box-shadow: 0 8px 30px 0 rgba(61,67,77,.08);
	}
	.goods{
		flex: 1;
		padding: 0 26px;
		background-color: #fff;
	}
	.Iwant{
		background-color: #155bd4;
		width: 158px;
		color: #fff;
		font-size: 16px;
		line-height: 24px;
		padding: 8px;
		display: block;
		margin: 0 auto;
		text-align: center;
		border-radius: 2px;
	}
	.chsmall-box{
		display: flex;
	}
	.item-p{
		font-size: 16px;
		color: #646566;
		line-height: 24px;
		margin-bottom: 60px;
	}
	.item-title{
		font-size: 26px;
		color: #323233;
		line-height: 36px;
		margin-bottom: 8px;
	}
	.item-pic{
		width: 72px;
		height: 72px;
		display: block;
		margin: 0 auto 24px;
	}
	.item-box{
		text-align: center;
		flex: 1;
	}
	.chainse{
		padding: 70px;
	}
	.name6{
		font-size: 44px;
		color: #fff;
		line-height: 52px;
		margin-bottom: 16px;
		font-weight: 500;
	}
	.Intro6{
		font-size: 20px;
		color: #c8c9cc;
		line-height: 28px;
	}
	.btnBox{
		margin-top: 32px;
	}
	.btn1{
		color: #fff;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		width: 158px;
		padding: 8px 0;
		border-radius: 2px;
		display: inline-block;
		background-color: #155bd4;
	}
	.btn2{
		color: #fff;
		font-size: 16px;
		line-height: 24px;
		text-align: center;
		width: 158px;
		padding: 8px 0;
		border-radius: 2px;
		display: inline-block;
		padding: 7px 0;
		margin-left: 16px;
		border: 1px solid #fff;
	}
}
</style>
